var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscendingCopy38(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "78DCB8E3-F87F-43EF-9277-315818D00AAB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-634.000000, -788.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-38",
    transform: "translate(634.000000, 788.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18,10.0120482 L10.9782135,10.0120482 L10.9782135,7 L7,11 L10.9782135,15 L10.9782135,11.9879518 L18,11.9879518 L18,10.0120482 Z M22,17 L18.0217865,13 L18.0217865,16.0120482 L11,16.0120482 L11,17.9879518 L18.0217865,17.9879518 L18.0217865,21 L22,17 Z",
    id: "pair",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingCopy38);
export default __webpack_public_path__ + "static/media/ascending Copy 38.f6721166061d0134aadaff52eb6803f7.svg";
export { ForwardRef as ReactComponent };